export const leaf: any = (obj: Record<string, any>, path: string) => (path.split('.').reduce((value, el) => value && value[el], obj));
